export default {
    login: {
        first: 'We create',
        second: 'sensor solutions for you.',
        third: 'Our simple but intelligent design will provide you with the tools to turn real-time data into immediately enhanced business performance.',
        first_flower: 'we colour the public space with our durable plant concepts',
        second_flower: '',
        third_flower: 'We provide flowering public green spaces and large gardens throughout Europe. We do this by supplying and planting flower bulbs, wild flowers and perennials.',
        desc: 'Log in by entering information below',
        username: 'Email',
        password: 'Password',
        successful: 'Login successful',
        logout: 'Log-out',
        log: 'Log',
        in: 'in',
    },
    dashboard: {
        title: 'Dashboard',
        search: 'Search',
        dealer_view: 'Dealer view',
        nav: {
            type: 'Type',
            batch: 'Calibration',
            location: 'Location',
            remark: 'Remark',
            lqi: 'Link',
            event: '',
            lqi_hover: 'Link Quality Indicator',
            unit: 'Unit',
            last_event: 'Last event',
            l_update: 'Last Data',
            timing: 'Dynamic timing',
            sensing: 'Dynamic sensing',
            notification: 'Notification',
            customer: 'Customer',
            favourite: 'Favourite',
        },
        bulk_setup: {
            substrate_properties: 'Substrate properties',
            frame_selection: 'Frame selection',
            critical_value: 'Notification thresholds',
            payload_error: 'Payload format of selected tentacles is not identical',
            hundred_tx_power: 'Calculated for 100% transmitting power.',
            version_error: 'Lifespan calculation is only available for devices with identical versions.',
            batch_type_error: 'Type of tentacle calibration is not identical (properties disabled)',
            batch_missing_error: 'One or more tentacle calibration is not set (properties disabled)',
            batch_all_error: 'To continue please set all properties',
            affected: 'Change applied to {count} devices',
            identical_version_error: 'Device versions are not identical',
        },
        remark: {
            double_click: 'Double click',
            to_add: 'to add value',
            history: 'Remark History',
            show_history: 'Show Remark History',
        },
    },
    map: {
        calculated: 'Calculated Location',
        manual: 'Manual Placement',
    },
    detail: {
        new_calib_point: 'Add new calibration point',
        remove_calib_point: 'Remove calibration point',
        raw_value: 'Raw value',
        calibrate_min: 'Calibrate min.',
        calibrate_max: 'Calibrate max.',
        apply_calib: 'Apply calibration to properties',
        reset_minmax: 'Reset min and max values',
        reset_calib: 'Reset to assigned calibration',
        select_props: 'Please select properties to calibrate',
        save_props: 'Save to selected properties',
        percent: 'VWC',
        batch: 'Calibration',
        selected_batch: 'Selected Calibration',
        raw: 'Raw',
        warning: 'Warning',
        warning_vwc: 'The value for VWC or the RAW equivalent is invalid.\n'
            + '        Please correct the values to be more then minimum,\n'
            + '        less than maximum or any other not existing value.',
        measured_min: 'Measured minimum',
        measured_max: 'Measured maximum',
        select_props: 'Select properties',
        lqi: 'Link Quality',
        lqi_calculated: 'Calculated using base stations.',
        map: 'Sensor location',
        sensor_setting: 'Sensor settings',
        etentacles_setting: 'iTentacles settings',
        min_value: 'Min value',
        last_value: 'Last value',
        max_value: 'Max value',
        select_data: 'Select data',
        missing: 'No data available',
        moisture_calibration: 'VWC Calibration',
        warning_batch_calibration: 'Warning! You are updating assigned calibration!',
        warning_device_calibration1: 'Warning! Calibration now applies only to this device',
        warning_device_calibration2: 'Warning! To apply calibration to properties - click "Apply calibration to properties"',
        device_only_label: 'Calibrate for device only',
        payload_format: 'Measurement frame (device)',
        payload_format_change: 'Change measurement frame',
        payload_format_not_set: 'Not updated yet',
        payload_format_changed: 'Last change',
        payload_format_updated: 'Last Updated',
        format: 'Frame',
        set_format: 'Set frame',

        dynamic_sensing: 'Dynamic sensing',
        measurement_frame: 'Measurement frame',
        none: 'None',
        moisture: 'Moisture',
        temperature: 'Temperature',
        light: 'Light',
        measurement_sets: 'Accumulated measurement sets',
        measurement_interval: 'Measurement interval',
        downlik_period: 'Downlink period',
        downlink_retries: 'Downlink retries',
        transmitting_power: 'Transmitting power',
        message_interval: 'Message Interval',
        device_lifespan: 'Device lifespan',
        once_per_four: 'Once per 4 days',
        once_per_two: 'Once per 2 days',
        once_per_day: 'Once per day',
        twice_per_day: 'Twice per day',
        set_dynamic_sensing: 'Set dynamic sensing',
    },
    lqi: {
        Excellent: 'Excellent',
        Good: 'Good',
        Average: 'Average',
        Limit: 'Limited',
    },
    server_status: {
        title: 'Server Status',
    },
    privacy: {
        title: 'Privacy & Policy',
    },
    sigfox_coverage: {
        title: 'Sigfox Coverage',
        coverage_error: 'Sigfox Coverage Service Error',
        unstable: 'There is no coverage and device may not sync.',
        works_underground: 'The link is strong and device should work underground or deep indoors.',
        possible_underground: 'The link is strong enough for the possibility to work underground or deep indoors.',
        works_indoor: 'The link is stable and device should work indoors (may not work underground).',
        possible_indoor: 'The link is stable enough for the possibility to work indoors. (may not work underground).',
        works_open: 'The link may not be stable and device should work on open field.',
        possible_open: 'The device got link and there is possibility that device should work on open field.',
        coverage_env: "Device placement",
        coverage_env_greenhouse: "Greenhouse",
        coverage_env_indoors: "Indoors",
        coverage_env_outdoors: "Outdoors",

    },
    payload: {
        title: 'Soil 3XS payload',
    },
    export: {
        limit: 'Pick last x values from selected tentacles',
        info: {
            first: 'Export',
            second: 'selected',
            rest: 'Firstly select some units from the table',
        },
        tabs: {
            date_range: 'Date range',
            limit_values: 'Limit values',
        },
    },
    contact_us: {
        title: 'Contact us',
        subj: 'Subject',
        mess: 'Message',
    },
    tooltips: {
        customer: 'Displaying tentacles assigned to this customer.',
        logout: 'Log-out',
        total_units: 'Total units',
        unit_name: 'Unit name',
        excel: 'Export to Excel file',
        csv: 'Export to CSV',
        search: 'or press',
        tentacle_missing: 'pick at least one tentacle',
    },
    buttons: {
        ok: 'Ok',
        login: 'Login',
        detail: 'Detail',
        apply: 'Apply changes',
        apply_range: 'Apply range',
        bulk: 'Bulk setup',
        bulkdetail: 'Bulk Detail',
        cancel: 'Cancel',
        send: 'Send',
        export: 'Export',
        delete_range: 'Delete Range',
        next: 'Next',
        previous: 'Prev',
        save: 'Save',
    },
    metrics: {
        pump_mode: 'Pump Running',
        power: 'Power',
        vfs_executed: 'VFS Executed',
        phase_1_disconnected: 'Phase 1 Disconnected',
        phase_2_disconnected: 'Phase 2 Disconnected',
        phase_3_disconnected: 'Phase 3 Disconnected',
        phase_correction_executed: 'Phase Correction Executed',
        l1_current_deviation: 'L1 Current Deviation',
        l1_current_deviation_5__max: 'L1 Current Deviation 5%',
        l1_current_deviation_10__max: 'L1 Current Deviation 10%',
        l2_current_deviation: 'L2 Current Deviation',
        l2_current_deviation_5__max: 'L2 Current Deviation 5%',
        l2_current_deviation_10__max: 'L2 Current Deviation 10%',
        l3_current_deviation: 'L3 Current Deviation',
        l3_current_deviation_5__max: 'L3 Current Deviation 5%',
        l3_current_deviation_10__max: 'L3 Current Deviation 10%',
        movement_during_ready_state: 'Movement During Ready State',
        frequency_deviation: 'Frequency Deviation',
        temperature_limit: 'Temperature Limit',
        ready_state_disabled_by_user: 'Ready State Disabled By User',
        real_power: 'Real Power',
        current_of_phase_1: 'Current of Phase 1',
        current_of_phase_2: 'Current of Phase 2',
        current_of_phase_3: 'Current of Phase 3',
        phase_angle_1: 'Phase Angle 1',
        phase_angle_2: 'Phase Angle 2',
        phase_angle_3: 'Phase Angle 3',
        gyroscope: 'Vibrations',
        real_power_on_start: 'Real Power On Start',
        current_of_phase_1_on_start: 'Current of Phase 1 on Start',
        current_of_phase_2_on_start: 'Current of Phase 2 on Start',
        current_of_phase_3_on_start: 'Current of Phase 3 on Start',
        phase_angle_1_on_start: 'Phase Angle 1 on Start',
        phase_angle_2_on_start: 'Phase Angle 2 on Start',
        phase_angle_3_on_start: 'Phase Angle 3 on Start',
        current_swing: 'Current Swing',
        hps_executed: 'HPS Executed',
        moisture: 'VWC',
        light: 'Light',
        temperature: 'Temperature',
        battery: 'Battery',
        pH: 'pH',
        ph: 'pH',
        pressure: 'Pressure',
        events: 'Events',
        currents: 'Phase Current',
        angles: 'Phase Angle',
        over_vibration_stop: 'Over-Vibration Stop',
    },
    timing: {
        t1: '15 minutes',
            t2: '30 minutes',
            t3: '1 hour',
            t4: '2 hours',
            t5: '8 hours',
            t6: 'Power off',
    },
    interval: {
        day: 'day',
            week: 'for week',
            month: 'for month',
            year: 'for year',
      customRange: 'Custom Range',
    },
    notifications: {
        sms: 'SNS',
            email: 'Email',
            push: 'Push notification',
    },
    sensing: {
        sens1: 'Current Soil 3XT-4',
            sens2: 'Original 2x per hour',
            sens3: 'Moisture 4x per hour',
            sens4: 'Moisture 3x per 45 min',
            sens5: 'Moisture/Temp 2x per 30 min',
            sens6: 'Moisture/Temp/Light 2x per 30 min',
    },
    info: {
        loading_data: 'Loading Data',
    },
    eventChart: {
        sequenceMessage: 'Expected sequence number was {previous} came {actual}',
        lqiMessage: 'Lqi is low for past {badCount} messages. Latest was "{lqi}"',
        invalidMessage: 'Device sending incorrect data',
        ackMessage: 'Device expected update was {expectedAt}',
        powerMessage: 'Device power output changed',
        settingsMessage: 'Device settings changed',
        sigfoxDeleted: 'Cloud OFF state',
        sigfoxCreated: 'Cloud ON state',
        deviceOn: 'Device ON',
        sigfoxDeletedMessage: 'Cloud device is set to OFF state',
        sigfoxCreatedMessage: 'Cloud device is set to ON state',
        deviceOnMessage: 'Device is ON remotely',
        sequence: 'Missing sequence number',
        lqi: 'Low LQI',
        power: 'Transmitting power change',
        settings: 'Settings changed',
        invalid: 'Invalid data',
        pendingChange: 'Pending Change',
        pendingChangeMessage: 'Device yet to apply changed settings.',
        ack: 'Settings not applied',
        info: 'Info',
        warning: 'Warning',
        error: 'Error',
        latestEvent: 'latest event',
        events: 'Events'
    },
    header: {
        custom_name: "Custom Name",
        generic_name: "Generic Name"
    }
};
